import styled from 'styled-components';

export const FormErrorStyle = styled.div`
    color: tomato;
`